(function () {
    "use strict";

    angular.module("app").controller("HistoryController", HistoryController);

    HistoryController.$inject = ["$rootScope", "$scope", "webApiServices", "notificationService", "guid",];
    function HistoryController($rootScope, $scope, webApiServices, notificationService, guid) {
        $scope.history = [];

        const requestSubject = "Request";

        $scope.Initialize = function (requestId, changes) {
            if (!requestId || guid.isEmpty(requestId))
                return;

            webApiServices.GetRequestHistory(
                { PublicId: requestId },
                processHistory,
                error => DoShowError(notificationService, error)
            );

            if (changes) {
                $scope.showChanges = (changes);
                $scope.groupedChanges = _.groupBy(changes, (c) => c.TableName);
            }
        };

        function processHistory(result) {
            if (!CheckResultReceived(result))
                return;

            for (const item of result.data) {
                if (item.StatusCode > 0 && item.Subject === requestSubject) {
                    item.Current = true;
                    break;
                }
            }

            $rootScope.history = result.data;
            $scope.history = result.data;
        }
    }
})();